












































































import Vue from "vue";
export default Vue.extend({
  computed: {
    areas() {
      return this.$store.state.localities;
    },
  },
  mounted() {
    this.$store.dispatch("loadLocalities");
  },
});
